export default "__VITE_ASSET__CVNmQZqM__"